import { Outlet, useLocation } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import ApiServices from "../../service/ApiServices";
import { useEffect, useState } from "react";

import { Footer } from "../navigation/footer/footer";
import { Header } from "../navigation/header/header";
import { LocationModal } from "../template/modal/location-modal/location-modal";

import './layout.css'
import { useSettings } from "../../app/context/settings-context/settings-context";
import { Style } from "./style/style";

const res = new ApiServices();

export const Layout = () => {
  const {settings: {banner, styles}, hasPayments, schedule} = useSettings();

  const location = useLocation();

  const [about, setAbout] = useState({});

  useEffect(() => {
    res.getAboutCompany().then(setAbout);
  }, [])

  return (
    <>
      <Style styles={styles}/>
      <motion.div className="content-wrap"
        key={location.key}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1, transition: { duration: 0.5 }}}
        exit={{ opacity: 0 }}
        style={{flex: '1 1 auto',
          paddingBottom: '65px',
          position: 'relative',
        }}
      >
        <Header props={{about, banner}}/>
        <main key={location.pathname} >
            <AnimatePresence mode="wait">
              <motion.div >
                <Outlet />
              </motion.div>
            </AnimatePresence>
        </main>
      </motion.div>
      {hasPayments() &&
        <Footer />
      }
      <LocationModal props={{about, schedule}}/>
    </>
  );
}
